import * as React from 'react';
import { SlideUpPanel } from 'mobile-ui/components/slideup-panel';
import { PanelHeader, CloseButton, PanelBody } from 'components';

import { actions as overlayWindowsActions } from 'services/overlay-windows/overlay-windows-service';
import { SubmitApplicationFormContent } from 'scenes/submit-application/form-content';
import { useSelector } from 'react-redux';
import { createSelector } from 'reselect';
import { IState } from 'services/root-reducer';
import { getOperationSafe } from 'selectors';
import { EOperationStatus } from 'types';
import { OverlayMessage } from 'scenes/overlay-message';
import { useTranslation } from 'react-i18next';


export const MobileUISubmitApplicationWrapper = () => {
    const submitApplicationOperation = useSelector(
        createSelector(
            (state: IState) => getOperationSafe(state, 'SUBMIT_APPLICATION_OVERLAY'),
            operation => operation
        )
    );

    const { t } = useTranslation();
    const [ showSubmitSuccess, setShowSubmitSuccess ] = React.useState<boolean>(false);

    const onCloseButtonClick = () => {
        overlayWindowsActions.hideApplicationOverlay();
        setShowSubmitSuccess(false);
    };

    const submitApplicationOverlayForm = useSelector(
        (state: IState) => getOperationSafe(state, 'SUBMIT_APPLICATION_OVERLAY_FORM')
    );

    React.useEffect(() => {
        if (submitApplicationOverlayForm.status === EOperationStatus.SUCCESS) {
            setShowSubmitSuccess(true);
        }
    }, [ submitApplicationOverlayForm.status ]);

    return (
        <React.Fragment>
            <SlideUpPanel
                fullscreen
                open={submitApplicationOperation.data?.visible ?? false}
                className='mobile-ui-submit-application fix-close-button'
            >
                <PanelHeader>
                    <CloseButton
                        onClick={onCloseButtonClick}
                    />
                </PanelHeader>

                <PanelBody>
                    <SubmitApplicationFormContent
                        onSubmit={(payload) => {
                            overlayWindowsActions.submitApplicationForm(payload);
                        }}
                    />
                </PanelBody>
            </SlideUpPanel>

            { showSubmitSuccess && (
                <OverlayMessage
                    messageText={t('Сообщение отправлено')}
                    onCloseButtonClick={onCloseButtonClick}
                />
            ) }
        </React.Fragment>
    );
};
